/**
 * Helpers for Quill / HTML page-content (Terms, Privacy).
 */

/** Strip tags and normalize whitespace; true when there's no visible text. */
export const isRichTextContentEmpty = html => {
  if (html == null) return true
  const text = String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\u00a0/g, " ")
    .replace(/\s+/g, " ")
    .trim()
  return text.length === 0
}

/** Portal/public locales that should show Arabic page content. */
export const isArabicPublicLang = value => {
  const lang = String(value || "")
    .trim()
    .toLowerCase()
  return lang === "sa" || lang === "ar"
}

/** Truncate a file name in the middle, keeping the extension when possible. */
export const truncateFileName = (fileName, maxLength = 28) => {
  const name = String(fileName || "").trim()
  if (!name || name.length <= maxLength) return name

  const lastDot = name.lastIndexOf(".")
  const hasExt = lastDot > 0 && lastDot < name.length - 1
  const ext = hasExt ? name.slice(lastDot) : ""
  const base = hasExt ? name.slice(0, lastDot) : name
  const available = Math.max(4, maxLength - ext.length - 1)
  if (base.length <= available) {
    return `${base}${ext}`
  }
  const head = Math.ceil(available / 2)
  const tail = Math.floor(available / 2)
  return `${base.slice(0, head)}…${base.slice(-tail)}${ext}`
}
